import { InspectAIP } from './pages/inspect.js'
import { commonPageSequence, reviewPage } from '../../../pages'

export const formSchema = saveComplaint => {
  // Append a review page to the common pages
  return {
    title: 'Select Agent/Import Permit Fraud Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: commonPageSequence({ includeVictim: false }).concat(
      reviewPage(InspectAIP)
    )
  }
}
